// extracted by mini-css-extract-plugin
export default {"primary-color":"#009bd1","page-padding":"20px","color-accent":"#009bd1","background-color":"#fafafa"};